module.exports = "/_next/static/images/c405124dd61bba7c291da5732279ea14-pencil.svg.webp";